module.exports = __webpack_public_path__ + "img/charge-marker-3.8ee63ca7.png";